import React, { Component } from "react";
import {
  Container,
  Box,
  Grid,
  Card,
  Typography,
  Button,
  IconButton,
  Paper,
  Divider,
  Avatar,
  AppBar,
} from "@mui/material";

import main_img from "../src/assets/svt.jpg";
import main_video from "../src/assets/hd.mp4";
import LayersIcon from "@mui/icons-material/Layers";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import rr from "../src/vendor_assets/d.webp";
import d from "../src/vendor_assets/d.webp";
import l from "../src/vendor_assets/l.webp";
import HomeIcon from "@mui/icons-material/Home";
import property from "../src/vendor_assets/property.webp";
import Paintingf from "../src/vendor_assets/Paintingf.jpg";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import car from "./vendor_assets/car.png";
import manufacturer from "./vendor_assets/manufacturer.png";
import penter from "./vendor_assets/penter.png";
import pent from "./vendor_assets/pent.jpg";
import repair from "./vendor_assets/repair.jpg";
import base from "../src/base.json";

export class VendorDescription extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ////// Personal Information (Vendors)

      vendor_personal_first_name: "",
      vendor_personal_last_name: "",
      vendor_personal_sirname: "",

      //////// Contact Details
      vender_personal_address: "",
      vender_personal_email: "",
      vender_personal_city: "",
      vender_personal_state: "",
      vender_personal_pincode: "",
      vendor_personal_whatsapp_no: "",
      vendor_personal_contact_number: "",

      ////////////  ID information
      vender_personal_abc_id: "",
      vendor_personal_pan_no: "",
      vendor_personal_adharcard_number: "",

      //////////  Financial Details
      vender_personal_bank_account_no: "",
      vendor_personal_bank_ifsc_code: "",
      vendor_personal_bank_name: "",
      vender_personal_bank_account_type: "",
      vendor_personal_bank_branch_name: "",
      vendor_personal_bank_account_holder_name: "",

      /////////// Attachment Details

      vendor_pan_card_docs: "",
      vendor_adhar_card_docs: "",
      vendor_bank_account_docs: "",
      vendor_address_docs: "",

      vendor_photo: [],
      vendor_video: [],
      vendors_thumb_nails_img: "",

      /////////////// Bussiness information //////////

      business_name: "",
      business_contact_no: "",
      bussiness_email_id: "",
      bussiness_exprence: "",

      bussiness_category: "",
      bussiness_sub_category: "",

      ///// swithch button for page change

      category_select_list: [],
      sub_category_List: [],

      is_switch_case: true,
      is_vendor_delete: false,
      is_loader_open: false,
    };
  }

  componentDidMount() {
    let idd = this.props.param.id.replace(/:/g, "");

    this.setState({ is_loader_open: true }, () => {
      fetch(`${base.base_url}/website/vendor/getSingleVendorDetails/:${idd}`, {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      })
        .then((res) => {
          return res.json();
        })
        .then((result) => {
          this.setState({
            vendor_personal_first_name: result.data.vendor_personal_first_name,
            vendor_personal_last_name: result.data.vendor_personal_last_name,
            vendor_personal_sirname: result.data.vendor_personal_sirname,

            //////// Contact Details
            vender_personal_address: result.data.vender_personal_address,
            vender_personal_email: result.data.vender_personal_email,
            vender_personal_city: result.data.vender_personal_city,
            vender_personal_state: result.data.vender_personal_state,
            vender_personal_pincode: result.data.vender_personal_pincode,
            vendor_personal_whatsapp_no:
              result.data.vendor_personal_whatsapp_no,
            vendor_personal_contact_number:
              result.data.vendor_personal_contact_number,

            ////////////  ID information
            vender_personal_abc_id: result.data.vender_personal_abc_id,
            vendor_personal_pan_no: result.data.vendor_personal_pan_no,
            vendor_personal_adharcard_number:
              result.data.vendor_personal_adharcard_number,

            //////////  Financial Details
            vender_personal_bank_account_no:
              result.data.vender_personal_bank_account_no,
            vendor_personal_bank_ifsc_code:
              result.data.vendor_personal_bank_ifsc_code,
            vendor_personal_bank_name: result.data.vendor_personal_bank_name,
            vender_personal_bank_account_type:
              result.data.vender_personal_bank_account_type,
            vendor_personal_bank_branch_name:
              result.data.vendor_personal_bank_branch_name,
            vendor_personal_bank_account_holder_name:
              result.data.vendor_personal_bank_account_holder_name,

            /////////// Attachment Details

            vendor_pan_card_docs: result.data.vendor_pan_card_docs,
            vendor_adhar_card_docs: result.data.vendor_adhar_card_docs,
            vendor_bank_account_docs: result.data.vendor_bank_account_docs,
            vendor_address_docs: result.data.vendor_address_docs,

            vendor_photo: result.data.vendor_photo,
            vendor_video: result.data.vendor_video,
            vendors_thumb_nails_img: result.data.vendors_thumb_nails_img,

            /////////////// Bussiness information //////////

            business_name: result.data.business_name,
            business_contact_no: result.data.business_contact_no,
            bussiness_email_id: result.data.bussiness_email_id,
            bussiness_exprence: result.data.bussiness_exprence,

            bussiness_category: result.data.bussiness_category,
            bussiness_sub_category: result.data.bussiness_sub_category,
            bussiness_desc : result.data.bussiness_desc,
            is_loader_open: false,
          });
        });
    });
  }

  render() {
    return (
      <div>
        <br />
        <br />
        <Box
          sx={{
            minHeight: 400,
            width: "100%",
            display: this.state.is_loader_open ? "none" : "block",
          }}
        >
          <Container maxWidth="xl">
            <br />
            <Grid container spacing={2}>
              <Grid item size={{ xs: 12, sm: 12, md: 8 }}>
                <Box
                  sx={{
                    minHeight: 300,
                    width: "100%",
                    // backgroundColor: "#fff",
                  }}
                >
                  <Grid container spacing={1}>
                    <Grid item size={{ xs: 12, sm: 12, md: 7 }}>
                      <img
                        src={
                          this.state.vendor_photo.length > 0
                            ? base.base_url +
                              "/" +
                              this.state.vendor_photo[0].name
                            : ""
                        }
                        style={{
                          height: 300,
                          width: "100%",
                          backgroundColor: "#fff",
                          objectFit: "cover",
                        }}
                      />

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          mt: -7,
                        }}
                      >
                        <Box sx={{ backgroundImage: "#eff0f0" }}>
                          <Typography
                            sx={{
                              fontSize: 13,
                              fontWeight: "700",
                              color: "#fff",
                              ml: 2,
                            }}
                          >
                            All Photos & Videos
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            backgroundImage: "#eff0f0",
                          }}
                        >
                          <LayersIcon sx={{ mr: 1, color: "#fff" }} />{" "}
                          <Typography
                            sx={{
                              fontSize: 13,
                              fontWeight: "700",
                              color: "#fff",
                              mr: 2,
                            }}
                          >
                            {this.state.vendor_photo.length}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 5 }}>
                      <Card
                        sx={{
                          height: 146,
                          width: "100%",
                          backgroundColor: "#fff",
                          border: 1,
                          borderColor: "#e3e5ea",
                          borderRadius: 1,
                        }}
                      >
                        <video
                          width="100%"
                          height="146"
                          style={{ objectFit: "cover" }}
                          controls
                        >
                          <source
                            src={
                              base.base_url +
                                "/" +
                                this.state.vendor_video.length >
                              0
                                ? this.state.vendor_video[0].name
                                : ""
                            }
                            type="video/mp4"
                          />
                        </video>
                      </Card>

                      <img
                        src={
                          this.state.vendor_photo.length > 0
                            ? base.base_url +
                              "/" +
                              this.state.vendor_photo[0].name
                            : ""
                        }
                        style={{
                          height: 147,
                          width: "100%",
                          backgroundColor: "#fff",
                        }}
                      />

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          mt: -6,
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{
                              fontSize: 12,
                              fontWeight: "700",
                              color: "#fff",
                              ml: 2,
                              textTransform: "uppercase",
                            }}
                          >
                            Outdoors
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <LayersIcon sx={{ mr: 1, color: "#fff" }} />{" "}
                          <Typography
                            sx={{
                              fontSize: 12,
                              fontWeight: "700",
                              color: "#fff",
                              mr: 2,
                            }}
                          >
                            {" "}
                            10
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
<br/>
                  <Box sx={{ display: "flex", flexDirection: "row", mt: 2 }}>
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        sx={{ fontSize: 19, fontWeight: "600", mt: 1 }}
                      >
                        {this.state.business_name}
                        <IconButton
                          color="primary"
                          aria-label="add to shopping cart"
                        >
                          <FavoriteBorderIcon />
                        </IconButton>
                      </Typography>
                      <Button
                        sx={{
                          height: 34,
                          fontSize: 11,
                          mt: 1,
                          fontWeight: "bold",
                        }}
                        variant="contained"
                        size="small"
                      >
                        Contact Vendor
                      </Button>
                    </Box>
                  </Box>

                  <Box sx={{ display: "flex", flexDirection: "row", mt: 2 }}>
                    <Box
                      sx={{
                        height: 20,
                        width: 70,
                        backgroundColor: "#0cb5b0",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        mr: 1,
                      }}
                    >
                      <DoneAllIcon
                        sx={{ height: 15, width: 15, color: "#fff" }}
                      />{" "}
                      <Typography
                        sx={{
                          fontSize: 10,
                          fontWeight: "600",
                          color: "#fff",
                          ml: 0.5,
                        }}
                      >
                        Verified
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        height: 20,
                        width: 90,
                        backgroundColor: "#d7f2e3",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        mr: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 10,
                          fontWeight: "600",
                          color: "green",
                          ml: 0.5,
                        }}
                      >
                        No Brokrage
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        height: 20,
                        width: 140,
                        backgroundColor: "#f7f7ff",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        mr: 1,
                      }}
                    >
                      <ViewInArIcon
                        sx={{ height: 15, width: 15, color: "#a6a3c0" }}
                      />{" "}
                      <Typography
                        sx={{
                          fontSize: 10,
                          fontWeight: "600",
                          color: "#a6a3c0",
                          ml: 0.5,
                        }}
                      >
                         Video Available
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        height: 20,
                        width: 110,
                        backgroundColor: "#f6fefe",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        mr: 1,
                      }}
                    >
                      <AddIcon
                        sx={{ height: 15, width: 15, color: "#04afaf" }}
                      />{" "}
                      <Typography
                        sx={{
                          fontSize: 10,
                          fontWeight: "600",
                          color: "#04afaf",
                          ml: 0.5,
                        }}
                      >
                        10 Top Fecilities
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      height: 100,
                      backgroundColor: "#f0f9ff",
                      width: "100%",
                      mt: 2,
                      borderRadius: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "black",
                        pt: 1,
                        ml: 1,
                        fontWeight: "600",
                        textTransform: "uppercase",
                      }}
                    >
                      Company Status
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 20,
                        color: "black",
                        pt: 0.5,
                        ml: 1,
                        fontWeight: "600",
                      }}
                    >
                      Currently Active
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "black",
                        ml: 1,
                        fontWeight: "500",
                      }}
                    >
                      Address : {this.state.vender_personal_address} 
                    </Typography>
                  </Box>

 





















                </Box>
              </Grid>

              <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                <Card
                  sx={{
                    minHeight: 200,
                    width: "100%",
                    backgroundColor: "#f3f6ff",
                  }}
                >
                  {" "}
                  {
                    /// WorkspacesIcon
                  }
                  <Typography
                    sx={{ fontSize: 16, fontWeight: "bold", padding: 2 }}
                  >
                    Why you should consider {this.state.business_name} - {this.state.vender_personal_city} ?
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "row", ml: 2, mr: 2 }}
                  >
                    <WorkspacesIcon sx={{ height: 14, width: 14, mt: 0.3 }} />{" "}
                    <Typography sx={{ fontSize: 13, ml: 1 }}>
                      {this.state.bussiness_desc}
                    </Typography>
                    <br/>
                  </Box>

                  <Divider />
                  <Typography sx={{ fontSize: 11, mt: 2, ml: 2 }}>
                   Vender Name : 
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 15,
                      ml: 2,
                      fontWeight: "800",
                      color: "black",
                      mt: 0.5,
                      textTransform: "uppercase",
                    }}
                  >
                    {this.state.business_name}
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "row", ml: 2, mt: 1 }}
                  >
                    <Button
                    onClick={()=>window.open(`tel:${this.state.vendor_personal_contact_number}`)}
                      variant="contained"
                      sx={{ height: 30, fontSize: 11, mr: 1 }}
                    >
                     Call Vendor
                    </Button>

                    <Button
                     onClick={()=>window.open(`mailto:${this.state.vender_personal_email}`)}
                      variant="outlined"
                      sx={{ height: 30, fontSize: 11 }}
                    >
                      Mail Vendor
                    </Button>
                  </Box>
                  <br />
                </Card>
              </Grid>


            </Grid>
          </Container>
        </Box>
      </div>
    );
  }
}

export default VendorDescription;

export function VendorDescriptionc(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams();
  return (
    <VendorDescription
      param={param}
      location={location}
      navigate={navigate}
    ></VendorDescription>
  );
}
